
function Image({ image }) {
    return (<img src={image.imageName} className={image.imageClassName} onClick={image.onClick} alt="" />)
}

export default Image